module.exports = __webpack_public_path__ + "resources/img/nhn-cloud-g-ogp.1aadbd6812eda14e3601d67cde7dfc53.jpg";